import React from 'react';
import { AiOutlineSearch } from 'react-icons/ai';
import { Popconfirm, Input, Button, Pagination, Row, Col, Select, Switch } from 'antd';
import { CheckOutlined, CloseOutlined, ReloadOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { SERVER_IP } from 'assets/Config';
import TableComponent from 'components/table-component';
import { deleteApi } from 'redux/sagas/deleteApiSaga';
import AddCustomer from 'pages/customers/add-customer';
import PayNowModal from 'pages/customers/pay-now';
// import ExcelDownload from 'components/excel-download';
import { getRowColor } from 'helpers';
import { useNavigate } from 'react-router-dom';
import { useI18n } from 'hooks/useI18n';

const CustomerListPresentational = ({
	filteredData,
	column,
	tableLoading,
	rowSelection,
	onTableChange,
	selectedRowKeys,
	handleAddCustomer,
	currentPage,
	pageSize,
	initialPageSizeOptions,
	initialPageSize,
	handlePaginationChange,
	paginationDetails,
	setSearchKey,
	getStartingValue,
	getEndingValue,
	customerAddModal,
	setCustomerAddModal,
	payNowAddModal,
	setPayNowAddModal,
	refreshList,
	editCustomer,
	handleClose,
	services,
	selectedService,
	setSelectedService,
	memberships,
	selectedMembership,
	setSelectedMembership,
	isExpiredCheck,
	setIsExpiredCheck,
	isInActiveCheck,
	setIsInActiveCheck,
	exportData,
}) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { t } = useI18n();
	const legendItems = [
		{ key: 'expired', label: t('reports.labels.expired'), className: 'is-expired' },
		{ key: 'expiring-soon', label: t('reports.labels.expiring_soon'), className: 'is-expiring-soon' },
		{ key: 'active', label: t('reports.labels.active'), className: 'is-active' },
	];

	return (
		<>
			<Row className="customer_list_page">
				<Col span={24} className="customer-list-page__table-wrap">
					<TableComponent
						loading={tableLoading}
						className="custom-table customer-list-page__table"
						style={{ width: '100%' }}
						columns={column}
						bordered
						showSorterTooltip
						rowClassName={(record) => {
							return getRowColor(record?.membership?.nextBillDate);
						}}
						rowKey={(record) => record.id}
						dataSource={tableLoading ? [] : filteredData}
						rowSelection={rowSelection}
						title={() => (
								<div className="customer-list-toolbar">
									<div className="customer-list-toolbar__copy">
										<span className="customer-list-toolbar__eyebrow">{t('customers.directory.eyebrow')}</span>
										<h3 className="customer-list-toolbar__title">{t('customers.directory.title')}</h3>
										<p className="customer-list-toolbar__subtitle">{t('customers.directory.subtitle')}</p>
									</div>
									<Row gutter={[12, 12]} className="customer-list-toolbar__controls">
										<Col xl={24}>
											<Row gutter={[10, 10]} align="stretch">
												<Col xs={24} sm={12} md={6} lg={5} xl={4}>
													<Input
														className="customer-list-toolbar__search"
														placeholder={t('ui.placeholders.search')}
														suffix={<AiOutlineSearch />}
														onChange={({ target: { value } }) => setSearchKey(value)}
													/>
												</Col>
												<Col xs={24} sm={12} md={6} lg={5} xl={4}>
													<Select
														className="customer-list-toolbar__select"
														allowClear
														placeholder={t('ui.placeholders.select_service')}
														value={selectedService}
														onChange={(value) => setSelectedService(value)}>
														{services?.map((service, index) => (
															<Select.Option key={index} value={service.id}>
																{service?.serviceName}
															</Select.Option>
														))}
													</Select>
												</Col>
												<Col xs={24} sm={12} md={6} lg={5} xl={4}>
													<Select
														className="customer-list-toolbar__select"
														disabled={!selectedService}
														allowClear
														placeholder={t('reports.placeholders.select_membership')}
														value={selectedMembership}
														onChange={(value) => setSelectedMembership(value)}>
														{memberships?.map((membership, index) => (
															<Select.Option key={index} value={membership.id}>
																{membership?.membershipName} - {membership?.offerPrice || membership?.originalPrice}
															</Select.Option>
														))}
													</Select>
												</Col>
												<Col xs={12} sm={6} md={4} lg={3} xl={3}>
													<div className={`customer-list-toolbar__toggle-card ${isExpiredCheck ? 'is-enabled' : ''}`}>
														<Switch
															checked={isExpiredCheck}
															onChange={(ev) => setIsExpiredCheck(ev)}
															checkedChildren={<CheckOutlined />}
															unCheckedChildren={<CloseOutlined />}
														/>
														<div className="customer-list-toolbar__toggle-label">{isExpiredCheck ? t('customers.expired') : t('ui.labels.show_expired')}</div>
													</div>
												</Col>
												<Col xs={12} sm={6} md={4} lg={3} xl={3}>
													<div className={`customer-list-toolbar__toggle-card ${isInActiveCheck ? 'is-enabled' : ''}`}>
														<Switch
															className="switch_inactive_user"
															checked={isInActiveCheck}
															onChange={(ev) => setIsInActiveCheck(ev)}
															checkedChildren={<CheckOutlined />}
															unCheckedChildren={<CloseOutlined />}
														/>
														<div className="customer-list-toolbar__toggle-label">{isInActiveCheck ? t('common.inactive') : t('ui.labels.show_inactive')}</div>
													</div>
												</Col>
												<Col
													xs={24}
													sm={24}
													md={24}
													lg={7}
													xl={6}
													className="customer-list-toolbar__actions-col">
													<div className="customer-list-toolbar__actions">
													<Button
														type="primary"
															className="customer-list-toolbar__reload-btn"
														icon={<ReloadOutlined />}
														loading={tableLoading}
														onClick={() => refreshList(true)}
													/>
													{/* <ExcelDownload {...{ ...exportData }} iconOnly /> */}
													<Button
														type="primary"
														onClick={handleAddCustomer}
															className="customer-list-toolbar__primary-btn">
														{t('customers.create_customer')}
													</Button>
													<Button
														type="link"
														onClick={() => navigate('/reports/customer')}
															className="customer-list-toolbar__report-link">
														{t('reports.title')}
													</Button>
													</div>
												</Col>
												{selectedRowKeys?.length === 1 ? (
													<Col xs={24} sm={12} md={6}>
														<Popconfirm
															title={t('messages.delete_confirm')}
															okText={t('common.delete')}
															cancelText={t('common.no')}
															onConfirm={() => {
																let url = `${SERVER_IP}api/customers/${selectedRowKeys?.[0]}`;
																dispatch(deleteApi('DELETE_CUSTOMER', url));
															}}>
															<div className="customer-list-toolbar__delete-link">
																{t('common.delete')}
															</div>
														</Popconfirm>
													</Col>
												) : null}
											</Row>
											<div className="customer-list-toolbar__legend-row">
												<div className="customer-list-toolbar__legend">
													<span className="customer-list-toolbar__legend-title">{t('customers.directory.status_guide')}</span>
													<div className="customer-list-toolbar__legend-list">
														{legendItems.map((item) => (
															<div key={item.key} className={`customer-list-toolbar__legend-item ${item.className}`}>
																<span className="customer-list-toolbar__legend-dot" />
																<span className="customer-list-toolbar__legend-label">{item.label}</span>
															</div>
														))}
													</div>
												</div>
											</div>
										</Col>
									</Row>
								</div>
						)}
						scroll={{ x: 1300 }}
						pagination={{
							current: currentPage,
							pageSize: pageSize,
							position: ['none', 'none'],
						}}
						footer={() => (
							<Row justify="space-between" className="customer-list-footer" align="middle">
								<Col span={12}>
									{!!paginationDetails?.totalRecords &&
										<span className="customer-list-footer__summary">
											{t('customers.directory.footer_range', {
												start: getStartingValue(),
												end: getEndingValue(),
												total: paginationDetails?.totalRecords,
											})}
										</span>}
								</Col>
								<Col span={12}>
									<div className="customer-list-footer__pagination">
										<Pagination
											pageSizeOptions={initialPageSizeOptions}
											defaultPageSize={initialPageSize}
											showSizeChanger={true}
											total={paginationDetails?.totalRecords}
											onChange={handlePaginationChange}
											responsive
										/>
									</div>
								</Col>
							</Row>
						)}
						onChange={onTableChange}
					/>
				</Col>
			</Row>
			<AddCustomer {...{ customerAddModal, setCustomerAddModal, refreshList, editCustomer, handleClose }} />
			<PayNowModal
				{...{
					payNowAddModal,
					setPayNowAddModal,
					refreshList,
					editCustomer,
					handleClose,
				}}
			/>
		</>
	);
};

export default CustomerListPresentational;
